import { Editor, Node, Text, Transforms } from 'slate';
import { isEqual } from 'lodash';

function ownProperties(node) {
  const result = {};
  for (const key of Object.keys(node)) {
    if (key !== 'children') {
      result[key] = node[key];
    }
  }
  return result;
}

function droppedKeys(node, normalized) {
  const result = [];
  for (const key of Object.keys(node)) {
    if (key !== 'children' && !Object.prototype.hasOwnProperty.call(normalized, key)) {
      result.push(key);
    }
  }
  return result;
}

function isValidPoint(editor, point) {
  if (!Node.has(editor, point.path)) {
    return false;
  }
  const node = Node.get(editor, point.path);
  return Text.isText(node) && point.offset <= node.text.length;
}

function restoreSelection(editor, selection) {
  if (selection && isValidPoint(editor, selection.anchor) && isValidPoint(editor, selection.focus)) {
    Transforms.select(editor, selection);
  }
}

function setProperties(editor, path, node, normalized) {
  Transforms.unsetNodes(editor, droppedKeys(node, normalized), { at: path });
  Transforms.setNodes(editor, ownProperties(normalized), { at: path });
}

function replaceHeader(editor, path, normalized) {
  const selection = editor.selection;
  Editor.withoutNormalizing(editor, function repairHeader() {
    Transforms.removeNodes(editor, { at: path });
    Transforms.insertNodes(editor, [normalized.node, ...normalized.overflow], { at: path });
  });
  restoreSelection(editor, selection);
}

// Saved headers can come back with their keys in another order, so compare values, not JSON text,
// and only rebuild the header when its regions really changed; rebuilding moves the caret away.
export function repairHeader(editor, path, node, normalized) {
  if (normalized.overflow.length > 0 || !isEqual(node.children, normalized.node.children)) {
    replaceHeader(editor, path, normalized);
    return true;
  }
  if (!isEqual(node, normalized.node)) {
    setProperties(editor, path, node, normalized.node);
    return true;
  }
  return false;
}
